import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import styled from 'styled-components';
import moment from 'moment';
import ProgressCircle from '../_MyTrainings/List/ProgressCircle';

const transition = '0.2s ease';

const Tile = styled.span`
  display: block;
  width: 100%;
  height: 100%;
  color: #000;

  .all-texts {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 37%;
    padding: 9% 10px 0;
    background: #fff;
    overflow: hidden;
    transition: height ${transition};
  }
  .training-title {
    display: block;
    font-weight: 700;
    white-space: nowrap;
    text-align: center;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .hidden-text {
    display: none;
  }
  :hover {
    .all-texts {
      height: 75%;
    }
    .percent-circle {
      bottom: 66%;
    }
    .hidden-text:not(.wrap-halfs) {
      display: block;
    }
    .hidden-text.wrap-halfs {
      display: flex;
    }
    .training-title {
      height: auto;
      overflow: visible;
    }
  }
`;

const Image = styled.span`
  width: 100%;
  height: 66%;
  display: block;
  background-size: cover;
  background-position: center center;
`;

const Percent = styled.span`
  position: absolute;
  bottom: 28%;
  left: 50%;
  margin-left: -36px;
  height: 72px;
  width: 72px;
  padding: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  background: #fff;
  z-index: 1;
  transition: bottom ${transition};

`;

const WrapHalfs = styled.span`
  position: absolute;
  top: 0;
  left: 10px;
  right: 10px;
  display: flex;
  justify-content: space-between;

  span {
    display: inline-block;
    font-size: 80%;
  }
`;

const LessonsItem = ({
  intl,
  item: {
    questions_count,
    correct_count,
    completed,
    completed_count,
    retries_count,
    retries_max,
    id,
    type,
    status,
    training_id,
    title,
    description,
    picture_from_training,
    quick_start,
    picture_link,
    started,
    started_ip,
    finished,
    finished_ip,
    due_date,
    completed_percent,
    correct_percent,
  },
  all_in_one_tab,
  new_question_new_tab,
}) => {
  const isLesson = id !== 'start' && id !== 'finish';
  let tileLink = '';

  if (isLesson && status !== 'upcoming') {
    tileLink = `/trainings/mytrainings/${training_id}/lessons/${id}`;

    if (quick_start) {
      tileLink = `/trainings/mytrainings/${training_id}/lessons/${id}/passing`;
    }
  } else {
    tileLink = `/trainings/mytrainings/${training_id}/${id}`;
  }

  const timeAllowed = due_date
    ? moment.duration(moment(due_date).diff()).days()
    : 0;

  // console.log('tileLink', tileLink);

  return (
    <Link
      to={tileLink}
      className={`tile_link ${status}`}
      style={{ padding: 0, backgroundColor: '#fff' }}
      onClick={(ev) => {
        if (status === 'upcoming') ev.preventDefault();
      }}
      target={new_question_new_tab && !all_in_one_tab ? "_blank" : "_self"}
    >
      {id === 'start' || id === 'finish' ? (
        <Tile>
          <Percent className="percent-circle">
            <ProgressCircle
              completed={completed_percent}
              correct={correct_percent}
            />
          </Percent>
          <span className="all-texts">
            {!!due_date && (
              <WrapHalfs className="wrap-halfs">
                <FormattedMessage
                  id="mytrainings_training_dueDate"
                  values={{ value: due_date }}
                />
                <FormattedMessage
                  id="mytrainings_training_timeAllowed"
                  values={{ value: timeAllowed }}
                />
              </WrapHalfs>
            )}
            <span className="training-title">
              <FormattedMessage id={title} />
            </span>
            <span className="hidden-text" style={{ textAlign: 'center' }}>
              <div>
                {/* {status === 'completed' ? 'Confirmed' : 'Not confirmed'} */}
                <FormattedMessage id={status === 'completed' ? 'overall_confirmed' : '-'} />
              </div>
              <div>{id === 'start' ? started : finished}</div>
              <div>{id === 'start' ? started_ip : finished_ip}</div>
            </span>
          </span>
        </Tile>
      ) : (
        <Tile>
          {picture_from_training && picture_link && (
            <Image
              style={{
                backgroundImage: `url(${picture_link}?w=300&h=300)`,
              }}
            />
          )}
          <Percent className="percent-circle">
            <ProgressCircle
              completed={completed_percent}
              correct={correct_percent}
            />
          </Percent>
          <span className="all-texts">
            <WrapHalfs className="wrap-halfs">
              <FormattedMessage id={`lessons_lesson_status_${status}`} />
              <FormattedMessage
                id="lessons_lesson_retries"
                values={{ retries_count, retries_max }}
              />
            </WrapHalfs>
            <span className="training-title">{title}</span>
            <span className="hidden-text">{description || ''}</span>
          </span>
        </Tile>
      )}
    </Link>
  );
};

LessonsItem.propTypes = {
  intl: PropTypes.objectOf(PropTypes.any),
  item: PropTypes.objectOf(PropTypes.any),
};

export default injectIntl(LessonsItem);



// WEBPACK FOOTER //
// ./src/views/_Lessons/GridItem.js